import _ from 'lodash';
import { actions, actionTypes } from './modules';
import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import { applicationIdsSelector, characterTargetIdSelector } from './selectors';
import { apiServiceAsync } from '../services/apiService';

const {
  loadCharacterRecruitmentProfileSuccess,
  loadCharacterRecruitmentProfileFail,

  requestApplicationSuccess,
  requestApplicationFail
} = actions;

function* fetchCharacterRecruitmentProfilesSaga(): any {
  const characterId = yield select(characterTargetIdSelector);

  try {
    const { profiles } = yield call(apiServiceAsync.getTargetRecruitmentProfiles, 'character', characterId);
    yield put(loadCharacterRecruitmentProfileSuccess(profiles));
  } catch (e) {
    yield put(loadCharacterRecruitmentProfileFail());
  }
}

function* requestCharacterApplicationSaga(): any {
  const applicationReq = yield select(applicationIdsSelector);
  try {
    const { recruitmentApplication } = yield call(apiServiceAsync.requestApplication, applicationReq);
    yield put(requestApplicationSuccess(recruitmentApplication.thread_id));
  } catch (e) {
    yield put(requestApplicationFail(e?.message));
  }
}

function* watchLoadCharacterRecruitmentPage(): any {
  yield takeLatest(actionTypes.LOAD_CHARACTER_RECRUITMENT_PROFILE, fetchCharacterRecruitmentProfilesSaga);
}

function* watchRequestApplication(): any {
  yield takeEvery(actionTypes.REQUEST_APPLICATION, requestCharacterApplicationSaga);
}

export default [watchLoadCharacterRecruitmentPage(), watchRequestApplication()];
